import React, { useState } from "react"
import { observer } from "mobx-react"
import {
  Button,
  Col,
  Flex,
  Form,
  FormInstance,
  FormListFieldData,
  Input,
  Row,
  Select,
} from "antd"
import { MinusCircleOutlined } from "@ant-design/icons"

import { WalletItem } from "@src/app/balanceStore"
import { CurrencyIcon } from "@src/app/components/CurrencyIcon"
import { DeleteConfirm } from "@src/app/components/DeleteConfirm"
import { notify } from "@src/app/components/notify"

type Props = {
  currencies: {
    isLoading?: boolean
    options: WalletItem[]
  }
  // errors: ReturnType<FormInstance["getFieldsError"]>
  field: FormListFieldData
  onRemove: (i: number) => void
}

export const MassPayoutCardsFormItem = observer(
  ({
    currencies,
    field: { key: fieldKey, name: fieldName, ...field },
    onRemove,
  }: Props) => {
    const [paymentToDelete, setPaymentToDelete] = useState(0)
    const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false)
    const form = Form.useFormInstance()

    const showDeleteConfirm = (payment: number) => {
      setPaymentToDelete(payment)
      setOpenDeleteConfirm(true)
    }

    const onDeleteConfirm = () => {
      onRemove(paymentToDelete)
      notify.success("Payment has been deleted")
      setOpenDeleteConfirm(false)
    }

    return (
      <>
        <Row align={"middle"} gutter={16}>
          <Col span={12}>
            <Form.Item
              {...field}
              label="Card"
              name={[String(fieldName), "card_number"]}
              rules={[
                {
                  message: "Please type card number",
                  required: true,
                },
              ]}
            >
              <Input placeholder="Enter card number" />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              {...field}
              dependencies={[["payouts", String(fieldName), "symbol"]]}
              label="Amount"
              name={[String(fieldName), "amount"]}
              rules={[
                {
                  message: "Please type amount",
                  required: true,
                },
              ]}
            >
              <Input placeholder="Enter amount" />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              {...field}
              label="Currency"
              name={[String(fieldName), "symbol"]}
              rules={[
                {
                  message: "Please select currency",
                  required: true,
                },
              ]}
            >
              <Select
                loading={currencies.isLoading}
                placeholder="Select currency"
              >
                {currencies.options.map((c) => (
                  <Select.Option key={c.symbol} value={c.symbol}>
                    <Flex align="center" gap={8} key={c.symbol}>
                      <CurrencyIcon network={"fiat"} symbol={c.symbol} />
                      {c.symbol}
                    </Flex>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={1}>
            <Form.Item label={"  "}>
              <Button
                icon={<MinusCircleOutlined />}
                id="GENERATED_ID_MANUALPAYOUTSFORMITEM_BUTTON_VOID_1"
                onClick={() => showDeleteConfirm(fieldName)}
                size={"small"}
                style={{ padding: 0 }}
                type={"text"}
              ></Button>
            </Form.Item>
          </Col>
        </Row>

        <DeleteConfirm
          cancelText="Cancel"
          isLoading={false}
          okText="Delete Payout"
          onCancel={() => setOpenDeleteConfirm(false)}
          onOk={() => onDeleteConfirm()}
          open={openDeleteConfirm}
          text="This action cannot be undone"
          title="Are you sure you want to delete this payout?"
        />
      </>
    )
  },
)
